import React from "react";

import { ButtonLink } from "../../components/ButtonLink/ButtonLink";
import { datas, planos, site } from "../../utils/copy";
import manuPadaria from "../../assets/images/ConversasTerapeuticas/hero.jpg";

export function Hero() {
  return (
    <section id="topo" data-bg="#f0eadb" className="poster-section hero-section">
      <div className="hero-frame">
        <div className="hero-paper">
          <div className="hero-copy">
            {/* Tudo nos 50% inferiores: marca → promessa → formato → datas+CTA */}
            <div className="hero-copy-stack">
              {/* Espaçadores flex: 40% do respiro livre acima da marca (ela
                  desce), 60% repartido nos 4 vãos entre blocos (= 40% menos
                  que o space-between antigo). CTA continua no pé. */}
              <div className="hero-flex-space hero-flex-space--lead" aria-hidden="true" />
              <div className="hero-block hero-block-brand">
                <h1 aria-label={`${site.name} ${site.assinatura}`}>
                  <span data-anim="l1" className="type-display">Conversas</span>
                  <span data-anim="l3" className="type-display">Terapêuticas</span>
                  <span data-anim="hero-label" className="type-voice hero-signature">{site.assinatura}</span>
                </h1>
              </div>
              <div className="hero-flex-space" aria-hidden="true" />

              <div className="hero-block hero-block-pitch">
                <p data-anim="hero-label" className="type-voice hero-intro">
                  Estudos e encontros entre mulheres<br />
                  para atravessar os dilemas da<br />
                  vida feminina
                  <span className="hero-gesture">
                    <span className="circled hero-circled">Juntas
                      <svg aria-hidden="true" viewBox="0 0 100 44" preserveAspectRatio="none">
                        <ellipse pathLength="1" cx="50" cy="22" rx="48" ry="18" />
                      </svg>
                    </span>
                    <span aria-hidden="true" className="hero-connector">
                      <b>*</b><i />
                    </span>
                  </span>
                </p>
              </div>
              <div className="hero-flex-space" aria-hidden="true" />

              <div className="hero-block hero-block-meta">
                <p data-anim="hero-label" className="hero-meta">Um ano · encontros ao vivo · entre mulheres</p>
              </div>
              <div className="hero-flex-space" aria-hidden="true" />

              <div className="hero-block hero-block-dates">
                {/* o contrato da turma na primeira dobra: antes as datas só
                    apareciam no fechamento, depois de 17 telas de rolagem, e o
                    "7 de setembro" não aparecia em lugar nenhum. Duas linhas
                    inquebráveis pra não sobrar órfã em 320px. */}
                {/* "Começa em" sozinho era ambíguo (começa o quê?). Em copy.ts o
                    7 de setembro é `inicio`, quando a TURMA começa; quem abre em
                    17 de agosto é `abertura`, a venda. Por isso o sujeito é a
                    turma, não a venda. */}
                <p data-anim="hero-label" className="hero-dates">
                  <span>A turma começa em {datas.inicioLongo}</span>
                  <span>Inscrições até {datas.fechamentoLongo}</span>
                </p>
              </div>
              <div className="hero-flex-space" aria-hidden="true" />

              <div className="hero-block hero-block-cta">
                <div data-anim="hero-label" className="hero-action">
                  <ButtonLink variant="solid" href="#investimento">{planos.anual.cta}</ButtonLink>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div data-anim="hero-foto" className="hero-photo">
          <div className="hero-photo-zoom">
            <img
              src={manuPadaria}
              alt="Manuela Xavier sorrindo, encostada no balcão de mármore de uma padaria movimentada"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
          {/* crédito do retrato (mobile): ancora a foto que fica abaixo do
              masthead; canto inferior, longe do rosto. Escondido no desktop. */}
          <span aria-hidden="true" className="hero-photo-credit type-voice">{site.assinatura}</span>
        </div>

        <span aria-hidden="true" className="poster-monogram">N</span>
      </div>
    </section>
  );
}
